module.exports = __webpack_public_path__ + "img/证书9.22fbc80e.jpg";